import { InputNumber as AntDInputNumber } from "antd"
import styled from "styled-components"

const InputNumber = styled(AntDInputNumber)`
  width: 100%;
  color: ${props => props.theme.color.fontColor.pinkColor3};
`

export { InputNumber }
